import React, { useEffect, useState } from "react";
import SuperUserHeader from "../../components/SuperUserHeader";
import SuperUserSideMenu from "../../components/SuperUserSideMenu";
import CompanyList from "./components/CompanyList";
import TextInput from "../../components/TextInput";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { useSelector, useDispatch } from "react-redux";
import {
    setSearchQuery,
    setCurrentPage,
    getCustomerCompanyList,
    setIsSearch,
} from "../../reducers/customerCompany";
import {trimStringFields} from "utils/format";

const CustomerCompany = () => {
    const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
    const {
        currentPage,
        companyList,
        pageSize,
        sortBy,
        sortOrder,
        searchQuery,
    } = useSelector((state: any) => state.customerCompany);

    const fetchCompanyList = (page = currentPage, search=searchQuery) => {
        let data = {
            searchQuery: search,
            page: page,
            pageSize: pageSize,
            sortBy: sortBy,
            sortOrder: sortOrder,
        }
        data = trimStringFields(data);
        dispatch(getCustomerCompanyList(data));
        dispatch(setCurrentPage(page));
    }

    useEffect(() => {
        fetchCompanyList();
    }, [sortBy, sortOrder, currentPage, pageSize]);

    const handleSearchCompany = (event: any) => {
        if (event.key === "Enter") {
            fetchCompanyList(1);
            if(searchQuery) dispatch(setIsSearch(true));
            else dispatch(setIsSearch(false));
        }
    };

    const handleSetSearchQuery = (value: string) => {
        dispatch(setSearchQuery(value));
    };

    const handleClearSearch = () => {
        handleSetSearchQuery("");
        fetchCompanyList(1, "");
    }

    return (
        <div className="bg-alu-base h-dvh">
        <SuperUserHeader />
        <div className="mt-6 px-6 flex gap-6 relative">
            <SuperUserSideMenu />
            <div className="flex-1">
                <div className="flex items-center justify-between">
                    <h1 className="text-xl font-bold leading-[1.875rem] alu-text-base-2 pl-4">
                        顧客企業一覧
                    </h1>
                    <TextInput
                        name="search"
                        value={searchQuery}
                        onChange={(e: any) => handleSetSearchQuery(e.target.value)}
                        onClearQuery={() => handleClearSearch()}
                        onKeyDown={(e: any) => handleSearchCompany(e)}
                        placeholder="検索"
                        searchIcon={true}
                    />
                </div>
                <div className="mt-6">
                    <CompanyList companyList={companyList} />
                </div>
            </div>
        </div>
        </div>
    );
};

export default CustomerCompany;
